import "./styles.scss";
import { CHECKBOX_ICONS } from "./constants";

type IconProps = {
    classname: string;
    src: string;
};
const Icon = ({ classname, src }: IconProps) => {
    return <img className={classname} src={src} alt="" />;
};

const CheckboxIcons = () => {
    return (
        <>
            {CHECKBOX_ICONS.map((icon) => {
                return <Icon {...icon} key={icon.key} />;
            })}
        </>
    );
};

type CheckboxLabelProps = {
    src: string;
    title: string;
};

const CheckboxLabel = ({ src, title }: CheckboxLabelProps) => {
    const iconProps = { classname: "icon", src };
    return (
        <div className="checkboxLabel">
            <Icon {...iconProps} />
            <span>
                {title}
                <span className="a11y">Filter</span>
            </span>
        </div>
    );
};

type FilterProps = {
    title: string;
    src: string;
    value: boolean;
    toggle: () => void;
};
const Filter = ({ title, src, value, toggle }: FilterProps) => {
    return (
        <label className="filter" data-testid="broadcast-filter">
            <CheckboxLabel title={title} src={src} />
            <input
                className="checkbox"
                type="checkbox"
                checked={value}
                onChange={toggle}
            />
            <CheckboxIcons />
        </label>
    );
};

export default Filter;
